var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 61"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "red"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 60,
    x: 0.5,
    y: 0.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 44,
    x: 5.5,
    y: 5.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1,
    x: 13.5,
    y: 54.5,
    rx: 0.5
  }))));
};
export default SvgPhoneIcon;